export default {
  aigc_upload_resource_upload: "Resource Upload",
  aigc_upload_resource_edit: "Editing Resources",
  aigc_upload_name: "Tool/Case name",
  aigc_upload_name_tips: "Please enter the name of the tool/case",
  aigc_upload_website: "Website",
  aigc_upload_website_tips: "Please enter the website",
  aigc_upload_internal: "Internally available",
  aigc_upload_tool_case: "Tool/Case",
  aigc_upload_tool: "Tool",
  aigc_upload_case: "Case",
  aigc_upload_type: "Type of tool/case",
  aigc_upload_type_tips: "Please select the type of tool/case",
  aigc_upload_application: "Application scenario",
  aigc_upload_application_tips: "Please select the application scenario",
  aigc_upload_description: "Brief description",
  aigc_upload_description_tips: "Please enter the brief description",
  aigc_upload_screenshot: "Additional description screenshot",
  aigc_upload_detailed_description: "Detailed description",
  aigc_upload_detailed_description_tips: "Please describe the use of the tool, scenarios and examples",
  aigc_upload_content: "Please describe the use of the tool, scenarios and examples",
  aigc_upload_submit: "Submit",
  aigc_upload_click: "Click to upload",
  aigc_upload_drag: "Drag to this area",
  aigc_upload_drag_tips: "Please upload a jpg/png file, size 1MB or less",
  aigc_upload_drag_tips2: "Please upload a json/csv file, size 1MB or less",
  aigc_upload_file_size: "File Size",
  aigc_upload_file_day: "Upload Day",
  aigc_upload_file_reupload: "Reupload",
  aigc_upload_file_cancel: "Upload Canceled",
  aigc_upload_file_delete: "Delete",
  aigc_upload_submit_success: "Submit Success",
  aigc_upload_submit_error: "Submit Error",
  aigc_upload_submit_warning: "Uploading image, please submit later",
  aigc_upload_edit_success: "Change successful",
  aigc_upload_edit_error: "Change Error",
};